import {Zchat} from './zchat';

window.zchat = Zchat.getInstance();
export default Zchat.getInstance();
